module.exports = __webpack_public_path__ + "img/search.685a9ed7.svg";